import { render, staticRenderFns } from "./VerifiedMoney.vue?vue&type=template&id=c067db2a&scoped=true"
import script from "./VerifiedMoney.vue?vue&type=script&lang=js"
export * from "./VerifiedMoney.vue?vue&type=script&lang=js"
import style0 from "./VerifiedMoney.vue?vue&type=style&index=0&id=c067db2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c067db2a",
  null
  
)

export default component.exports